import React, { useRef } from 'react'
import classNames from 'clsx'

import {
  ContentSize,
  ContentSizeEnum,
  type VideosContent as VideosContentType,
} from '../../../../../shared/types'
import { parentMeta } from '../../type'
import styles from './VideosContent.module.scss'

// import defaultPoster from '../../assets/default-poster.jpg' // Adjust path accordingly
// const DEFAULT_POSTER = '/images/default-poster.jpg'
// TODO: fix default poster

interface VideosContentProps {
  parentMeta?: parentMeta
  content: VideosContentType
  filePath?: string
  size?: ContentSize
  placeholderImage?: string
}

const VideosContent = (props: VideosContentProps) => {
  const { parentMeta, filePath, content, size, placeholderImage } = props
  const { fileNames } = content

  // Optional: Refs to control each video
  const videoRefs = useRef<HTMLVideoElement[]>([])

  // Click handler to unmute a specific video
  const handleVideoClick = (index: number) => {
    const video = videoRefs.current[index]
    if (video) {
      video.muted = false
      video.volume = 1.0
      video.play().catch((err) => {
        console.error('Playback failed:', err)
      })
    }
  }

  return (
    <div
      className={classNames(
        styles.videosContentRoot,
        size === ContentSizeEnum.Small ? styles.small : ''
      )}
    >
      {fileNames.map((videoFile, index) => (
        <video
          key={index}
          ref={(el) => {
            if (el) videoRefs.current[index] = el
          }}
          className={styles.video}
          src={`${filePath}${videoFile}`}
          // poster={placeholderImage || defaultPoster}
          poster={placeholderImage}
          preload="metadata"
          autoPlay
          loop
          muted
          playsInline
          onClick={() => handleVideoClick(index)}
        >
          Your browser does not support the video tag.
        </video>
      ))}
    </div>
  )
}

export default VideosContent
